import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { AUTH_URL, getUrl, zitadelRoutes } from "../../../includes/routes";
import { useZitadel } from "../../../contexts/ZitadelContext";
import Landing from "./Landing";
import MfaInitialisation from "./MfaPages/MfaInitialisation";
import TotpChallenge from "./MfaPages/TotpChallenge";
import OtpEmailChallenge from "./MfaPages/OtpEmailChallenge";

const ZitadelMfaDispatch = () => {
    const { session, loginInfo } = useZitadel();

    if (!session || !loginInfo) return <Navigate to={getUrl(AUTH_URL)} replace />;

    const { isMfaRegistrationRequired, isTotpChallengeRequired, isOtpEmailChallengeRequired } = session.metadata;

    if (isTotpChallengeRequired) return <Navigate to={getUrl(zitadelRoutes.TOTP_CHALLENGE.route)} replace />;
    if (isOtpEmailChallengeRequired) return <Navigate to={getUrl(zitadelRoutes.OTP_EMAIL_CHALLENGE.route)} replace />;
    if (isMfaRegistrationRequired) return <Navigate to={getUrl(zitadelRoutes.MFA_INITIALISATION.route)} replace />;

    return <Navigate to={getUrl(AUTH_URL)} replace />;
};

const MfaInitialisationGuard = () => {
    const { session, loginInfo } = useZitadel();

    if (!session || !loginInfo) return <Navigate to={getUrl(AUTH_URL)} replace />;

    const { isMfaRegistrationRequired, isTotpChallengeRequired, isOtpEmailChallengeRequired } = session.metadata;

    if (isTotpChallengeRequired) return <Navigate to={getUrl(zitadelRoutes.TOTP_CHALLENGE.route)} replace />;
    if (isOtpEmailChallengeRequired) return <Navigate to={getUrl(zitadelRoutes.OTP_EMAIL_CHALLENGE.route)} replace />;
    if (isMfaRegistrationRequired) return <Outlet />;

    return <Navigate to={getUrl(AUTH_URL)} replace />;
};

const TotpChallengeGuard = () => {
    const { session, loginInfo, totpRegistration } = useZitadel();

    if (!session || !loginInfo) return <Navigate to={getUrl(AUTH_URL)} replace />;

    const { isMfaRegistrationRequired, isTotpChallengeRequired, isOtpEmailChallengeRequired } = session.metadata;

    if (isTotpChallengeRequired) {
        if (!isMfaRegistrationRequired || totpRegistration) return <Outlet />;
        return <Navigate to={getUrl(AUTH_URL)} replace />;
    }
    if (isOtpEmailChallengeRequired) return <Navigate to={getUrl(zitadelRoutes.OTP_EMAIL_CHALLENGE.route)} replace />;
    if (isMfaRegistrationRequired) return <Navigate to={getUrl(zitadelRoutes.MFA_INITIALISATION.route)} replace />;

    return <Navigate to={getUrl(AUTH_URL)} replace />;
};

const OtpEmailChallengeGuard = () => {
    const { session, loginInfo } = useZitadel();

    if (!session || !loginInfo) return <Navigate to={getUrl(AUTH_URL)} replace />;

    const { isMfaRegistrationRequired, isTotpChallengeRequired, isOtpEmailChallengeRequired } = session.metadata;

    if (isOtpEmailChallengeRequired) return <Outlet />;
    if (isTotpChallengeRequired) return <Navigate to={getUrl(zitadelRoutes.TOTP_CHALLENGE.route)} replace />;
    if (isMfaRegistrationRequired) return <Navigate to={getUrl(zitadelRoutes.MFA_INITIALISATION.route)} replace />;

    return <Navigate to={getUrl(AUTH_URL)} replace />;
};

const ZitadelRouter = () => {
    return (
        <Routes>
            <Route path="landing" element={<Landing />} />
            <Route path="mfa" element={<ZitadelMfaDispatch />} />
            <Route element={<MfaInitialisationGuard />}>
                <Route path="mfa-initialise" element={<MfaInitialisation />} />
            </Route>
            <Route element={<TotpChallengeGuard />}>
                <Route path="totp" element={<TotpChallenge />} />
            </Route>
            <Route element={<OtpEmailChallengeGuard />}>
                <Route path="otp-email" element={<OtpEmailChallenge />} />
            </Route>
            <Route path="*" element={<Navigate to={getUrl(AUTH_URL)} replace />} />
        </Routes>
    );
};

export default ZitadelRouter;
